'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _site = require('./site.html');

var _site2 = _interopRequireDefault(_site);

var _site3 = require('./site.controller');

var _site4 = _interopRequireDefault(_site3);

require('./site.styl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteComponent = {
  restrict: 'E',
  bindings: {},
  template: _site2.default,
  controller: _site4.default,
  controllerAs: 'vm'
};

exports.default = siteComponent;


// WEBPACK FOOTER //
// ./client/app/common/admin/site/site.component.js